module.exports = __webpack_public_path__ + "static/media/mask.1f569e57.png";